import React, { Component } from 'react';
import { connect } from '@souche-f2e/muji';
import { dispatch } from '../../../../.muji/store';
import Session from '../../../../components/Session/index';
const mapStateToProps = (rootState) => ({
    session: rootState.session,
    currentRoute: rootState.router,
});
class CreateSession extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    componentWillMount() {
        const query = this.props.currentRoute.query;
        dispatch.session.CHANGE_PAGE_STATE(0); // 创建
        dispatch.session.SET_STATE({
            query,
        });
    }
    render() {
        return (<Session title={'发拍场次设置'}/>);
    }
}
export default connect(mapStateToProps)(CreateSession);
